import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';

const regex = /^{?[0-9a-zA-Z]{8}-([0-9a-zA-Z]{4}-){3}[0-9a-zA-Z]{12}}?$/;

export const guidGuard =
  (param: string = 'guid'): CanActivateFn =>
  (route) => {
    const router = inject(Router);
    const routeParam = route.params[param];

    if (routeParam && regex.test(routeParam)) {
      return true;
    }

    return router.createUrlTree(['/']);
  };
